/**
 * Who raised a review hint (Spec § 3.5): the model's own `pruefhinweise`, or
 * the domain's post-parse checks (numbers not in the transcript, an empty
 * Heilmittel, a trimmed repetition loop). Shown as an icon in the review UI,
 * never saved into the documentation item.
 */
export var ReviewHintSource;
(function (ReviewHintSource) {
    ReviewHintSource["MODEL"] = "model";
    ReviewHintSource["SYSTEM"] = "system";
})(ReviewHintSource || (ReviewHintSource = {}));
//# sourceMappingURL=review-hint-source.enum.js.map